import { render, staticRenderFns } from "./IBVNProviderChart.vue?vue&type=template&id=284c97a2&"
import script from "./IBVNProviderChart.vue?vue&type=script&lang=js&"
export * from "./IBVNProviderChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports